import * as Yup from 'yup';

import GooglePlacesAPI from '../../../../../../api/GooglePlacesAPI';

export const useLocationFilter = ({ setFilters }) => {
  const locationRadiusOptions = [
    { label: 'Within 10 miles (16km)', value: 10 },
    { label: 'Within 25 miles (40km)', value: 25 },
    { label: 'Within 50 miles (80km)', value: 50 },
    { label: 'Within 100 miles (160km)', value: 100 },
    { label: 'Within 200 miles (320km)', value: 200 },
  ];

  const formSchema = Yup.object().shape({
    locationIds: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
        type: Yup.string(),
      }),
    ),
    locationRadius: Yup.object().shape({
      label: Yup.string(),
      value: Yup.number(),
    }),
  });

  const onSearchChange = (q) =>
    GooglePlacesAPI.searchGoogle(q).then((results) =>
      results.map(({ label, value: apiValue, type }) => ({
        label,
        value: apiValue,
        type,
      })),
    ); // eslint-disable-line function-paren-newline

  const onSubmit = ({ locationIds, locationRadius: radius }) => {
    const hasLocalityLocation = locationIds?.some((item) => item.type === 'locality');
    const defaultRadius = { label: 'Within 10 miles (16km)', value: 10 };

    setFilters({
      locationIds,
      locationRadius: hasLocalityLocation ? radius || defaultRadius : undefined,
    });
  };

  return { locationRadiusOptions, formSchema, onSearchChange, onSubmit };
};
